(function(angular, defineProperties) {
    'use strict';

    angular.module('aprima-core').factory('ObjUtil', [
        '_',
        ObjUtil,
    ]);
    
    function ObjUtil(
        _
    ) {
        var service = {
            defineReadonlyProps: defineReadonlyProps,
            defineStaticProps: defineStaticProps,
        };

        return service;

        // readonly properties that are enumerable
        function defineReadonlyProps(obj, propertiesObj) {
            if(!_.isObject(propertiesObj)) {
                throw new Error('Expected defineReadonlyProps to be called with object instead of ' + propertiesObj);
            }

            var properties = _.mapValues(propertiesObj, function(val) {
                return {
                    value: val,
                    writable: false,
                    enumerable: true,
                    configurable: false,
                };
            });
            return defineProperties(obj, properties);
        }

        // readonly, but not enumerable
        function defineStaticProps(obj, propertiesObj) {
            if(!_.isObject(propertiesObj)) {
                throw new Error('Expected defineStaticProps to be called with object instead of ' + propertiesObj);
            }

            var properties = _.mapValues(propertiesObj, function(val) {
                return {
                    value: val,
                    writable: false,
                    enumerable: false,
                    configurable: false,
                };
            });
            return defineProperties(obj, properties);
        }
    }

})(window.angular, window.Object.defineProperties);
